// Normaliza a resposta da API de favoritos para sempre retornar um array.
// A API pode retornar um array, { data: [...] }, { items: [...] },
// { Registros: [...] }, um objeto único ou um payload de erro.
export const normalizeFavorites = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.items)) return payload.items;
  if (Array.isArray(payload?.Registros)) return payload.Registros;
  if (payload && typeof payload === 'object') return [payload];
  return [];
};
